import React, { useEffect, useRef, useState } from "react";
import TotalUserTable from "../../components/AssignTask/TotalUserTable";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Link,
  Button,
  TextField,
  InputAdornment,
  List,
  ListItem,
  ListItemText,
  Tooltip,
  Tab,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ScheduledAssign from "../../components/AssignTask/ScheduledAssign";
import CreateCohort from "../../components/AssignTask/CreateCohort";
import { getallusers, getalltaskbyid, staticcsvcohort } from "./api";
import { getToken } from "../../utils/utils";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import CohortView from "../../components/AssignTask/CohortView";
import { useAlert } from "../AlertContext/AlertContext";
import { AxiosError, AxiosResponse } from 'axios';

interface AssignTaskProps {
  branddetailslength1: number;
}

interface TaskData {
  task_name: string;
  credit_points: string;
  durations: string;
}

const AssignTask: React.FC<AssignTaskProps> = ({ branddetailslength1 }) => {
  const [cohortIds, setCohortIds] = useState<string[]>([]);
  const [unselectedIds, setUnselectedIds] = useState<number[]>([]);
  const [selectedDate1, setSelectedDate1] = useState<Date | null>(null);
  const [selectedTime, setSelectedTime] = useState<string | null>(null);
  const [selectedTaskIds, setSelectedTaskIds] = useState<string[]>([]);
const [totalCreditPoints, setTotalCreditPoints] = useState(0);
  const [totalRetailers, setTotalRetailers] = useState(0);

  const navigate = useNavigate();
  const { id } = useParams<{ id?: string }>();
  useEffect(() => {
    if (!id) return; // stop if id is falsy

    console.log(id, "ssssssweeeee");

    navigate(`/assign-task/${id}`, { state: { idifisdi: id } });
    console.log("kkfkdfkjkfjsa");
  }, [id, navigate]);
  const token = getToken();
  const [branddetails, setBrandDetails] = useState<any[]>([]);
  const [gettaskdata, setGetTaskData] = useState<TaskData | null>(null);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [missingidssssss, setMissingidssssss] = useState<number[]>([]);
const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [uploadStatus, setUploadStatus] = useState<string>(""); // State for upload feedback
  const fileInputRef = useRef<HTMLInputElement>(null); // Ref for file input

  const [cohortIds2, setCohortIds2] = useState<string[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [checkbaledata, setcheckbaledata] = useState([]);

  const [locationsCount, setLocationsCount] = useState(0);
    const [budgetsCount, setbudgetCount] = useState(0);
 const [actualamountCount, setactualamounttCount] = useState(0);
 const [assignedCount, setassignesCount] = useState(0);
 const [userdatadata, setuserdatadata] = useState("");
  const [searchLength, setSearchLength] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);
  const [locationsLabel11, setLocationsLabel] = useState<string[]>([]);
  const [outletLabel22, setOutletLabel] = useState<string[]>([]);
  const [cohortexist, setCohortExist] = useState<
    "cohort exists" | "no cohort" | ""
  >("");
  const [options, setOptions] = useState<string[]>(id ? ["2"] : ["1"]);
  const [value, setValue] = useState(id ? "2" : "1");
const [selectedCohortStatuses, setSelectedCohortStatuses] = useState<Record<string, string>>({});
  const [cohortSchedules, setCohortSchedules] = useState<{ [key: string]: string }>({});

  // Debounce search term
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);
    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);

  // Fetch task data if id is present
  useEffect(() => {
    if (!id || !token) {
      setCohortExist("");
      setGetTaskData(null);
      return;
    }
    const fetchAllTaskIds = async () => {
      try {
        const reqBody = { task_id: id };
        const response = await getalltaskbyid(reqBody, token);
        const brandDetailsData = response?.data?.data || {};
        setCohortExist(brandDetailsData.findcohorts || "no cohort");
        setGetTaskData({
          task_name: brandDetailsData.task_name || "",
          credit_points: brandDetailsData.credit_points || "",
          durations: brandDetailsData.durations || "",
        });
      } catch (error: any) {
        console.error(
          "Error fetching task name:",
          error.response?.data || error.message
        );
        setCohortExist("no cohort");
        setGetTaskData(null);
      }
    };
    fetchAllTaskIds();
  }, [id, token]);

  // Fetch brand details for "All Vendors" tab
  useEffect(() => {
    if (!id || value !== "2" || !token) return;
    const fetchDropdownBrandDetails = async () => {
      try {
        const reqBody = {
          locations: locationsLabel11.filter(
            (label) => label.trim() !== "All Locations"
          ),
          outlet_type: outletLabel22.filter(
            (label) => label.trim() !== "All Outlet Types"
          ),
          search: debouncedSearchTerm,
          task_id: id,
          page: String(page),
          limit: String(limit),
        };
        const response = await getallusers(reqBody, token);
        if (response?.data?.data) {
          const brandDetailsData = response.data.data;
          setTotalCount(brandDetailsData.Totalcount || 0);
          setLocationsCount(brandDetailsData.locationscount || 0);
          setSearchLength(brandDetailsData.searchlength || 0);
          setbudgetCount(brandDetailsData.Budgetsamount || 0)
                setactualamounttCount(brandDetailsData.actualamount || 0)
                   setassignesCount(brandDetailsData.assignedusers || 0)
                   setuserdatadata(brandDetailsData.userdata)
          setBrandDetails(
            brandDetailsData.results?.map((item: any) => ({
              id: item.user_id || "",
              pmpmiEntityCodei: item.pmi_entity_code || "",
              retailerName: item.retailer_name || "",
              outletName: item.outlet_name || "",
              outletType: item.outlet_type || "",
              location: item.locations || "",
              finduserretailersids: item.finduserretailersids || "",
              schedulemapping:item.schedulemapping || "",
              

            })) || []
          );
        }
      } catch (error: any) {
        console.error(
          "Error fetching brand details:",
          error.response?.data || error.message
        );
      }
    };
    fetchDropdownBrandDetails();
  }, [
    page,
    limit,
    debouncedSearchTerm,
    token,
    locationsLabel11,
    outletLabel22,
    value,
    id,
  ]);

  // Update tab options based on cohortexist and id
  useEffect(() => {
    if (!id) {
      setOptions(["1"]);
      setValue("1");
    } else if (cohortexist === "cohort exists") {
      setOptions(["1", "2"]);
      setValue("1");
    } else {
      setOptions(["2"]);
      setValue("2");
    }
  }, [cohortexist, id]);

  // Handle tab change
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    if (options.includes(newValue)) {
      setValue(newValue);
    }
  };

  // Calculate total pages
  const totalPages = Math.ceil(
    debouncedSearchTerm ? branddetails.length : totalCount / limit
  );
  const location = useLocation();

  const path = location.pathname.replace(/\/$/, "");
  const { showAlert } = useAlert();

  const handleFileUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (!file) {
      setUploadStatus("No file selected.");
      return;
    }

    // Validate file type
    if (!file.name.endsWith(".xlsx") && !file.name.endsWith(".xls")) {
      setUploadStatus("Please upload an Excel file (.xlsx or .xls).");
      return;
    }

    setUploadStatus("Uploading...");

    const formData = new FormData();
    formData.append("retailers_list", file);
    formData.append("location", ""); // Hardcoded as per your curl example
    formData.append("language", ""); // Hardcoded as per your curl example

    try {
      const response = await staticcsvcohort(formData, token); // Use apiClient
      setUploadStatus("File uploaded successfully!");
      // Update cohortIds or other state based on response
      console.log("API Response:", response.data);
      showAlert("successfully upload the file!", "success");

      navigate(`/cohorts-view`);
      setTimeout(() => window.location.reload(), 100);
      // Example: setCohortIds(response.data.cohortIds || []);
      //   } catch (error: any) {
      //     console.error(
      //       "Error uploading file:",
      //       error.response?.data || error.message
      //     );
      //     setUploadStatus(`Failed to upload file: ${error.message}`);
      //     showAlert("failed to  upload the file!", "failed");
      //   }

      //   // Reset file input
      //   if (fileInputRef.current) {
      //     fileInputRef.current.value = "";
      //   }
      // };
    } catch (error: unknown) {
    if (error instanceof AxiosError && error.response?.data) {
      // API returns { error: "..." } instead of { message: "..." }
      const apiErrorMessage =
        (error.response.data as any).error ||
        "An unexpected error occurred while saving the cohort.";
      console.error("Error saving cohort:", apiErrorMessage);
      showAlert(apiErrorMessage, "error");
      setUploadStatus(`Failed to upload file: ${apiErrorMessage}`);
    } else if (error instanceof Error) {
      console.error("Error saving cohort:", error);
      showAlert(error.message, "error");
      setUploadStatus(`Failed to upload file: ${error.message}`);
    } else {
      console.error("Unknown error saving cohort:", error);
      showAlert("An unexpected error occurred.", "error");
      setUploadStatus("Failed to upload file: An unexpected error occurred.");
    }

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  }
};

  // Trigger file input click
  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  const showCohortTab = !location.pathname.startsWith("/cohorts-view");
    const showtaskTab = !location.pathname.startsWith("/assign-task/");

console.log(cohortIds, "cohortIdscohortIdscohortIds")
  return (
    <div>
      <Box sx={{ padding: "24px 32px 0", background: "#fff " }}>
        {/* <Link
          href="/manage-task"
          sx={{
            textDecoration: "none",
            fontSize: "14px",
            fontWeight: "500",
            color: "rgba(105, 106, 107, 1)",
          }}
        >
                  Tasks /
      </Link>
          <Link
          sx={{
            textDecoration: "none",
            fontSize: "14px",
            fontWeight: "600",
            color: "rgba(142, 2, 15, 1)",
          }}
        >
                  Assign Tasksssss
      </Link> */}

        {path === "/cohorts-view" ? (
          <>
            <Link
              href="/manage-task"
              sx={{
                textDecoration: "none",
                fontSize: "14px",
                fontWeight: "500",
                color: "rgba(105, 106, 107, 1)",
              }}
            >
              Task /&nbsp;
            </Link>
            <Link
              href="/cohorts-view"
              sx={{
                textDecoration: "none",
                fontSize: "14px",
                fontWeight: "600",
                color: "rgba(142, 2, 15, 1)",
              }}
            >
              Cohort View
            </Link>
          </>
        ) : (
          <>
            <Link
              href="/manage-task"
              sx={{
                textDecoration: "none",
                fontSize: "14px",
                fontWeight: "500",
                color: "rgba(105, 106, 107, 1)",
              }}
            >
              Tasks /
            </Link>
            <Link
              sx={{
                textDecoration: "none",
                fontSize: "14px",
                fontWeight: "600",
                color: "rgba(142, 2, 15, 1)",
              }}
            >
              Assign-task
            </Link>
          </>
        )}
        {/* <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}> */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            position: "relative",
            top: -10,
          }}
        >
          <Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: "24px",
                fontWeight: "600",
                color: "#000",
                marginTop: "16px",
              }}
            >
              {gettaskdata?.task_name || (id ? "Loading..." : "Cohort View")}
            </Typography>
          </Box>
     {showtaskTab && (
          <Box sx={{ display: "flex", gap: "20px" }}>
            <Tooltip title="Upload & Check Users" arrow>
              <Button
                sx={{
                  borderRadius: "8px",
                  padding: "13px",
                  color: "#c8172f",
                  textDecoration: "none",
                  border: "1px solid #c8172f",
                  textAlign: "center",
                  fontSize: "14px",
                  fontWeight: "500",
                  textTransform: "none",
                  width: "200px",
                  background: "#fff",
                  position: "relative",
                  height: "49px",
                }}
                onClick={handleButtonClick}
              >
                Upload The Cohort Users
              </Button>
            </Tooltip>
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              accept=".xlsx,.xls"
              onChange={handleFileUpload}
            />
            {/* <CreateCohort buttonText="Create Cohort" buttonVariant="contained" buttonIcon="" /> */}

            <Box
              sx={{
                position: "relative",
                // marginLeft: "-21px",
                height: "57px",
                // marginTop: "11px",
                // marginRight: "39px",
              }}
            >
              <CreateCohort
                buttonText="Static Cohort"
                buttonVariant="contained"
                buttonIcon={""}
                cohorttype={"Static Cohort"}
              />
            </Box>
            <Box
              sx={{
                position: "relative",
                height: "51px",
              }}
            >
              <CreateCohort
                buttonText={"Dynamic Cohort"}
                buttonVariant={"contained"}
                buttonIcon={""}
                cohorttype={"Dynamic Cohort"}
                sx={{
                  position: "relative",
                  padding: "25px",
                  whiteSpace: "pre",
                  height: "14px",
                  width: "170px",
                  // marginTop: "6px",
                  margin: "0"
                }}
              />
            </Box>
          </Box>
        )}
        </Box>
        {id && (
          <Box
            sx={{
              background: "#F9FBFC",
              marginTop: "20px",
              marginBottom: "20px",
            }}
          >
            <Box sx={{ width: "450px", paddingLeft: "20px" }}>
              <List sx={{ display: "flex" }}>
                <ListItem sx={{ paddingLeft: "0" }}>
                  <label style={{ color: "#494A4B" }} htmlFor="name">
                    Points:
                  </label>
                  <strong id="name"> {gettaskdata?.credit_points}</strong>
                </ListItem>
             {assignedCount !== 0 && (
                <>
                <ListItem sx={{ paddingLeft: "0" }}>
                  <label htmlFor="name">Budjet:</label>
                  <strong id="name">{budgetsCount}</strong>
                </ListItem>
                <ListItem sx={{ paddingLeft: "0" }}>
                  <label htmlFor="name">Actual Amount:</label>
                  <strong id="name">{actualamountCount}</strong>
                </ListItem>
                </>
                )}
              </List>
            </Box>
          </Box>
        )}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingBottom: "30px",
          }}
        >
          <TextField
            required
            placeholder={
              Number(value) === 2
                ? "Search by PMI Entity Code, Outlet Name, Location"
                : "Search by folder name, filters"
            }
            sx={{
              ".MuiOutlinedInput-root": {
                borderRadius: "12px",
                height: "48px",
                width: "521px",
                "@media (max-width:1366px)": {
                  width: "400px",
                },
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </Box>
      </Box>

      <TabContext value={value}>
        <Box
          sx={{ borderTop: 1, borderColor: "divider", background: "#f9fbfc" }}
        >
          <TabList
            className="cohort-tab"
            sx={{
              ".MuiTabs-flexContainer": {
                float: "right",
                marginRight: "32px",
                marginTop: "20px",
                background: "#EEF4FF",
                borderRadius: "256px",
                padding: "2px",
              },
            }}
            onChange={handleChange}
            aria-label="lab API tabs example"
          >
            {/* {showCohortTab &&
              <Tab
                sx={{
                  "&.Mui-selected": {
                    background: "#FFF",
                    borderRadius: "256px",
                    color: "#282829",
                    fontSize: "14px",
                    fontWeight: "500",
                    boxShadow: "0px 0px 2px 0px #c8c8c8",
                  },
                  color: "#696A6B",
                  fontWeight: "400",
                }}
                label="Cohort Viewsssss"
                value="1"
              />
            } */}
            {options.includes("2") && (
              <Tab
                sx={{
                  "&.Mui-selected": {
                    background: "#FFF",
                    borderRadius: "256px",
                    color: "#282829",
                    fontSize: "14px",
                    fontWeight: "500",
                    boxShadow: "0px 0px 2px 0px #c8c8c8",
                  },
                  color: "#696A6B",
                  fontWeight: "400",
                }}
                label="All Vendors"
                value="2"
              />
            )}
          </TabList>
        </Box>
        <TabPanel value="1">
          <CohortView
          totalCreditPoints={totalCreditPoints}
      setTotalCreditPoints={setTotalCreditPoints}
      totalRetailers={totalRetailers}
      setTotalRetailers={setTotalRetailers}
       cohortSchedules={cohortSchedules}
        setCohortSchedules={setCohortSchedules}
          selectedTaskIds={selectedTaskIds}            
  setSelectedTaskIds={setSelectedTaskIds} 
          selectedCohortStatuses={selectedCohortStatuses}
      setSelectedCohortStatuses={setSelectedCohortStatuses}
            cohortIds={cohortIds}
            debouncedSearchTerm={debouncedSearchTerm}
            searchTerm={searchTerm}
            setCohortIds={setCohortIds}
            title={""}
            cohortIds2={[]}
            setCohortIds2={setCohortIds2}
            value={value}
          />
        </TabPanel>
        <TabPanel value="2">
          <TotalUserTable
          userdatadata={userdatadata}
          selectedRows={selectedRows}
    setSelectedRows={setSelectedRows}
            value={value}
            branddetails={branddetails}
            totalCount={totalCount}
            locationsCount={locationsCount}
            searchTerm={searchTerm}
            Searchlength={String(searchLength)}
            page={page}
            limit={limit}
            totalPages={totalPages}
            setPage={setPage}
            debouncedSearchTerm={debouncedSearchTerm}
            branddetailslength={branddetails.length}
            locationsLabel11={locationsLabel11}
            outletLabel22={outletLabel22}
            setLocationsLabel={setLocationsLabel}
            setOutletLabel={setOutletLabel}
          />
        </TabPanel>
      </TabContext>
      <Box sx={{ background: "#fff" }}>
        <ScheduledAssign
        totalCreditPoints={totalCreditPoints}
        setTotalCreditPoints={setTotalCreditPoints}
        totalRetailers={totalRetailers}
        setTotalRetailers={setTotalRetailers}
       cohortSchedules={cohortSchedules}
        setCohortSchedules={setCohortSchedules}
        userdatadata={userdatadata}
          selectedTaskIds={selectedTaskIds}            // ✅ pass it here
  setSelectedTaskIds={setSelectedTaskIds} 
        selectedCohortStatuses={selectedCohortStatuses}
      setSelectedCohortStatuses={setSelectedCohortStatuses}
          assignedCount={assignedCount} 
gettaskdata={gettaskdata}
    setGetTaskData={setGetTaskData}
         selectedRows={selectedRows}
    setSelectedRows={setSelectedRows}
          missingidssssss={missingidssssss}
          checkbaledata={checkbaledata}
          unselectedIds={unselectedIds}
          value={value}
          cohortIds={cohortIds}
          setSelectedDate1={setSelectedDate1}
          selectedDate1={selectedDate1}
          setSelectedTime={setSelectedTime}
          selectedTime={selectedTime}
          cohorttaskid={""}
          selected={[]}
        />
      </Box>
    </div>
  );
};

export default AssignTask;
